/**
 * "vor 3 Tagen" statt "16.09.2026".
 *
 * Auf einem Board, das dauerhaft läuft, ist der Abstand die Information und
 * nicht das Datum: Niemand rechnet im Laden aus, wie lange der letzte Einkauf
 * her ist. Tage statt Stunden, weil eine Einkaufsliste in Tagen denkt.
 */
export function vorWieLange(iso: string, jetzt = new Date()): string {
  const tage = Math.floor((jetzt.getTime() - Date.parse(iso)) / 86_400_000);

  if (tage <= 0) return "heute";
  if (tage === 1) return "gestern";
  if (tage < 7) return `vor ${String(tage)} Tagen`;
  if (tage < 14) return "vor einer Woche";
  if (tage < 31) return `vor ${String(Math.floor(tage / 7))} Wochen`;
  if (tage < 61) return "vor einem Monat";
  return `vor ${String(Math.floor(tage / 30))} Monaten`;
}

/**
 * "gerade eben", "vor 3 Minuten", "vor 2 Stunden", danach wie vorWieLange.
 *
 * Für den Abgleich mit der Spaisekammer: Dort ist die Frage "ist das frisch",
 * und die beantwortet man in Minuten, nicht in Tagen.
 */
export function vorWieLangeGenau(iso: string, jetzt = new Date()): string {
  const sekunden = Math.floor((jetzt.getTime() - Date.parse(iso)) / 1000);
  if (!Number.isFinite(sekunden)) return "unbekannt";
  if (sekunden < 60) return "gerade eben";

  const minuten = Math.floor(sekunden / 60);
  if (minuten < 60) return minuten === 1 ? "vor einer Minute" : `vor ${String(minuten)} Minuten`;

  const stunden = Math.floor(minuten / 60);
  if (stunden < 24) return stunden === 1 ? "vor einer Stunde" : `vor ${String(stunden)} Stunden`;

  return vorWieLange(iso, jetzt);
}
